export const appConfig = {
  name: 'LeCartte',
  description: 'Cardápio digital inteligente para restaurantes',
} as const;

export type AppConfig = typeof appConfig;
